export const EVENT_IMAGE_URLS = [
  "/IMG_5610.jpg",
  "/IMG_5609.jpg",
  "/IMG_5608.jpg",
  "/IMG_5607.jpg",
  "/IMG_5606.jpg",
  "/IMG_5605.jpg",
  "/post-mntm.ai-sep-15-2025-1.jpeg",
  "/post-mntm.ai-sep-15-2025-2.jpeg",
  "/post-mntm.ai-sep-15-2025-3.jpeg",
  "/post-mntm.ai-sep-15-2025-4.jpeg",
  "/post-mntm.ai-sep-15-2025.jpeg",
  "/Screenshot%202025-11-26%20at%202.30.37%E2%80%AFAM.png"
];

export const TEAM_IMAGE_URLS = [
  "/subquat.jpeg",
  "/Ebad.jpg",
  "/arhum.jpeg",
  "/momina.jpeg",
  "/tulika.jpeg",
  "/syed.jpeg",
  "/abaker.jpeg"
];

export const PRELOAD_IMAGE_URLS = [...EVENT_IMAGE_URLS, ...TEAM_IMAGE_URLS];



